import AdapterDateFns from '@mui/lab/AdapterDateFns'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { Locale } from '../helpers'
import { useStyles } from '../pages/styled'
import DateTextField from './DateTextField'
import CalendarLogo from './LogoCalendar'

type DatePickerPropsType = {
  value: Date | null
  onChange: (date: Date | null) => void
  label: string | any
  name: string
  helperText: React.ReactNode
  error: boolean
  required?: Boolean
  minDate?: Date
  maxDate?: Date
  placeholder?: string
  disabled?: boolean
}

export const DatePicker = (params: DatePickerPropsType) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const lang = t('appl.header.language') === 'EN' ? 'en' : 'pl'

  const { handleBlur } = useFormikContext()

  /*
function adjustDateStrDot(dateStr: string) {
    // returns DateStr formated to d.m.y format; only digits, dot or comma expected
    let s = dateStr.replace(/[^.|\d]/g, '') // filter all except digits and dot
    s = s.replace(/^\d\d\d$/, s.substring(0, 2) + '.' + s.substring(2)) //insert dot after two day digits
    s = s.replace(/^\d\d.\d\d\d$/, s.substring(0, 5) + '.' + s.substring(5)) // insert dot after two month digits
    return s
  }
  //    ?.toString() .replace(dateRegex, (reg) => (mask.test(reg) ? reg : ''))

  function adjustDateStrDDMMYYYY(dateStr: string) {
    // returns dateStr formatted to dd.mm.yyyy format; only digits and dots expected
      let s = dateStr;
      const s = s.replace(/^[1-9]./, '0' + s.substring(0, 3));     // format days
      const s = s.replace(/^\d\d.[1-9]./, s.substring(0, 4) + '0' + s.substring(4, 6))   // format month
      const s = s.replace(/^\d\d.\d\d.\d\d$/, s.substring(0, 7) + '20' + s.substring(7))  // complete two digit year
      return s
    }
      Použití nějak takto:
          onChange={(e) => {setFieldValue('email', adjustDateStrDot(e.target.value))
          }}
          onBlur = {(e) => {
            setFieldValue('email', adjustDateStrDDMMYYYY(e.target.value));
          }}
  const mask = /^d{2}[.]d{4}$/g
  */

  return (
    <LocalizationProvider
      locale={lang === 'en' ? `` : Locale}
      dateAdapter={AdapterDateFns}
    >
      <DesktopDatePicker
        renderInput={(props) => (
          <DateTextField
            {...props}
            name={params?.name}
            label={params?.label}
            error={params?.error}
            helperText={params?.helperText}
            className={classes.fieldSize}
            onBlur={handleBlur}
            required={params?.required}
          />
        )}
        inputFormat="dd.MM.yyyy"
        //@ts-ignore
        autoOk="true"
        margin="normal"
        maxDate={params?.maxDate || new Date()}
        minDate={params?.minDate || new Date(1900, 0, 1)}
        value={params?.value}
        onChange={(value) => {
          params?.onChange(value)
        }}
        InputProps={{ required: false }}
        components={{ OpenPickerIcon: CalendarLogo }}
        disableHighlightToday={true}
        disableMaskedInput={true}
        placeholder={params?.placeholder}
        disabled={params?.disabled}
        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
      />
    </LocalizationProvider>
  )
}
